


































import { Component } from "vue-property-decorator";
import { Mixins } from "vue-mixin-decorator";
import GeneralMixin from "@/mixin";
import { Action, Getter, Mutation } from "vuex-class";

import CostList from "@/components/admin/list/CostList.vue";
import { ICompanyImage } from "@/types/company_image";
import { IUser } from "@/types/user";

@Component({
  components: { CostList }
})
export default class extends Mixins<GeneralMixin>(GeneralMixin) {
  @Action("company_image/adminGet")
  public getCompanyImage!: (company_id: number) => boolean;

  @Getter("company_image/single")
  public company_image!: ICompanyImage;

  @Getter("auth/me")
  public user!: IUser;

  @Mutation("company_image/clear")
  public clearCompanyImage!: () => void;

  public company_id = 0;
  public async created() {
    this.company_id = this.user.company_id;

    await Promise.all([this.getCompanyImage(this.company_id)]);
  }
}
